let routes = [
    {
        path: '/behavioural-model-lineage',
        name: 'behavioural-model-lineage',
        component: () => import('@/modules/managers/behaviouralModelLineage/BehaviouralModelLineage.vue')
    }
]

export default routes
